import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';


export function NavBarOne({ target })
{

    const [token, setToken] = useState( localStorage.getItem('token') );

    const signOut = ()=>{
       localStorage.clear();
       setToken();
    } 

    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > 60); 
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
  

    return(

        <nav className={`navbar navbar-expand-lg p-3 ${isSticky ? "fixed-top shadow navBar-outline" : "transition-2"}`}>
            <div className="container-fluid px-4 py-2">

                {/* <!-- toggle button --> */}
                <button className="navbar-toggler mb-4" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* <!-- links --> */}
                <div className="collapse navbar-collapse justify-content-between" id="navbarNavAltMarkup">
                    <div className="navbar-nav">
                        <div className="d-flex align-items-center">
                            <span className="font-lg color-green ps-3 pe-1 rounded-start-1 bg-light" > SAMA </span>
                            <span className="font-lg color-green bg-orange ps-1 pe-3 rounded-end-1" > DOC </span>
                        </div>
                    </div>
                    <div className="navbar-nav gap-x-4 gap-y-2">          
                        <div>  <a className={`btn btn-sm rounded-0 px-3 ${ ( target === 'home' ) ? 'btn-orange-outline' : 'btn-orange-outline' }`} href="/"> { ( target === 'home' ) && <i className="bi bi-arrow-left me-1"></i> }  Accueil </a> </div>
                        <div> <a className= {`btn btn-sm btn-orange-outline rounded-0 px-3`} href="/apropos"> { ( target === 'about' ) && <i className="bi bi-arrow-left me-1"></i> }  Apropos </a> </div>
                        {
                          token ? ( 
                                <div className='d-flex align-items-center'> 
                                    <button className="btn btn-sm btn-orange rounded-0 px-3" onClick={ signOut }> Deconnexion </button>
                                </div>
                          ) : (
                                <div className='d-flex align-items-center'> 
                                   <a className="btn btn-sm btn-orange rounded-0 px-3" href="/connexion"> Connexion </a> 
                                </div>
                          )
                        }
                    </div>
                </div>

            </div>
        </nav>

    )
}



export function NavBarTwo({ target })
{
    const [token, setToken] = useState( localStorage.getItem('token') );

    const signOut = ()=>{
       localStorage.clear();
       setToken();
    } 

    return(

        <nav className={`navbar navbar-expand-lg p-3 shadow bg-green-dark`}>
            <div className="container-fluid px-4 py-2">

                {/* <!-- toggle button --> */}
                <button className="navbar-toggler bg-light" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* <!-- links --> */}
                <div className="collapse navbar-collapse justify-content-between" id="navbarNavAltMarkup">
                    <div className="navbar-nav">
                        <div className="d-flex align-items-center ">
                            <span className="font-lg color-green ps-3 pe-1 rounded-start-1 bg-light" > SAMA </span>
                            <span className="font-lg color-green bg-orange ps-1 pe-3 rounded-end-1" > DOC </span>
                        </div>
                    </div>
                    <div className="navbar-nav gap-x-4">          
                        <div>  <a className={`btn btn-sm rounded-0 px-3 ${ ( target === 'home' ) ? 'btn-orange-outline' : 'btn-orange-outline' }`} href="/"> { ( target === 'home' ) && <i className="bi bi-arrow-left me-1"></i> }  Accueil </a> </div>
                        <div> <a className= {`btn btn-sm btn-orange-outline rounded-0 px-3`} href="/apropos"> { ( target === 'about' ) && <i className="bi bi-arrow-left me-1"></i> }  Apropos </a> </div>
                        {
                          token ? ( 
                                <div className='d-flex align-items-center'> 
                                    <button className="btn btn-sm btn-orange rounded-0 px-3" onClick={ signOut }> Deconnexion </button>
                                </div>
                          ) : (
                                <div className='d-flex align-items-center'> 
                                   <a className="btn btn-sm btn-orange rounded-0 px-3" href="/connexion"> Connexion </a> 
                                </div>
                          )
                        }
                    </div>
                </div>

            </div>
        </nav>

    )
}



export function NavBarThree({ target })
{

    const navigate = useNavigate();

    const signOut = ()=>{
        localStorage.clear()
        navigate('/')
    }

    return(

        <nav className={`navbar navbar-expand-lg p-2`}>
            <div className="container-fluid px-4 py-2">

                {/* <!-- toggle button --> */}
                <button className="navbar-toggler bg-green" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* <!-- links --> */}
                <div className="collapse navbar-collapse justify-content-between" id="navbarNavAltMarkup">
                    <div className="navbar-nav">
                        <div className="d-flex align-items-center ">
                            <span className="font-lg color-light ps-3 pe-1 rounded-start-1 bg-green border border-success" > SAMA </span>
                            <span className="font-lg color-green border ps-1 pe-3 rounded-end-1" > DOC </span>
                        </div>
                    </div>
                    <div className="navbar-nav gap-4">          
                        <a className={`nav-link link-green-outline ${ ( target === 'panel' ) ? 'color-green' : '' }`} href="/panel"> Accueil </a>
                        <a className={`nav-link link-green-outline ${ ( target === 'repository' ) ? 'color-green' : '' }`} href="/repertoires"> Repertoires </a>
                        <a className= {`nav-link link-green-outline ${ ( target === 'profil' ) ? 'color-green' : '' }`} href="/profile"> Profile </a>
                        <button className="btn btn-sm btn-green-outline" onClick={ signOut }> Deconnexion </button>
                    </div>
                </div>

            </div>
        </nav>

    )
}